import { render, staticRenderFns } from "./ChosePage.vue?vue&type=template&id=27dfdb94&scoped=true"
import script from "./ChosePage.vue?vue&type=script&lang=js"
export * from "./ChosePage.vue?vue&type=script&lang=js"
import style0 from "./ChosePage.vue?vue&type=style&index=0&id=27dfdb94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dfdb94",
  null
  
)

export default component.exports